import React, { Component } from 'react';
import { leadID } from '../Services/fetchService';
import {
    DomField,
    DomSelect,
    DomBoolCheckbox,
    DomTextarea,
    DomCustomImage
} from '../Services/formDOM';
import { checkInput, returnValue } from '../Services/Validation';
import { GA_Push } from '../Services/GoogleAnalytics';
import { apiURL, Environment } from '../Services/Base';
import Loading from '../Services/Loading/Loading';
import { _getCookie } from "../Services/Cookies/Cookies";
import 'whatwg-fetch';
import './Body.scss';

export default class Body extends Component {
    constructor() {
        super();
        this.state = {
            isOpen: false,
            isBusy: false,
            isLoading: false,
            // isLoading: true,
            pageStyle: 'form',
            // pageStyle: "done",
            // pageStyle: "already",
            // Thats for the osem independence day
            TOS2: false,
            // FileName: {
            //     value: '',
            //     name: 'FileName',
            //     error: '',
            //     isRequired: true,
            //     shouldValidate: true,
            //     ImagePlaceholder: '<span>צירוף תמונה עד</span> <span>5MB</span> <span>(JPEG, PNG,GIF)</span>'
            // },
            captchaEnable: !Environment().isLocalhost
        };
        window.sendCallback = this.sendForm;
    }

    componentDidMount() {
        // let date = new Date().toISOString().split('T')[0].split('-')
        let date = new Date()
        let year = date.getFullYear() 
        let month = date.getMonth() + 1
        let day = date.getDate()
        console.log(`d:${day} / m:${month} / y:${year}`)
        if(year >= 2021 && month >= 4 && day >= 8){
            this.setState({ pageStyle: 'ended' });
            return;
        }
        if (!!window.localStorage.getItem('OSEM_AlreadySent') === true) {
            this.setState({ pageStyle: 'already' });
            return;
        }
        (() => {
            if (window.document.getElementById('GoogleRecap')) return;

            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = 'GoogleRecap';
            script.async = 1;
            script.defer = 1;
            script.src = 'https://www.google.com/recaptcha/api.js';

            document.getElementsByTagName('head')[0].appendChild(script);
        })();
    }

    addState = (stateName, isRequired, shouldValidate) => {
        this.setState({
            [stateName]: {
                name: stateName,
                value: '',
                isRequired: !isRequired ? false : true,
                shouldValidate: !shouldValidate ? false : true
            }
        });
    };

    handleInputChange = async event => {
        // if (event.target.value.length > 200) return;
        // Thats for the osem independence day
        if(event.target.name == "TOS2"){
            await this.setState( {TOS2:!(this.state.TOS2)})
            return;
        }
        this.setState({
            [event.target.name]: {
                ...this.state[event.target.name],
                error: '',
                value:
                    event.target.dataset && event.target.dataset.bool === 'true'
                        ? this.state[event.target.name].value
                            ? 0
                            : 1
                        : event.target.value
            }
        });
    };

    setErrorMessage = (target, errorMsg) => {
        if (!this.state[target.name]) return;

        this.setState({
            [target.name]: {
                ...target,
                error: errorMsg
            }
        });
    };

    openModal = () => this.setState({ isOpen: true });

    setPage = pageStyle =>
        this.setState({
            pageStyle: pageStyle
        });

    checkString = event => {
        let { name, value } = event.target;
        switch (name) {
            default:
                return value;
        }
    };

    onlyLetters = string => string.replace(/[0-9]/i, '');

    onlyNumbers = string =>
        string.replace(/[+\\/!*@#$%^&a-zA-Z\-\u0590-\u05FF]/i, '');



    saveAndValidate = async () => {
        if (this.state.isBusy) return;

        this.setState({
            isLoading: true,
            isBusy: true
        });

        let isError = false,
            j = 0,
            jsonBody = {},
            stateValidate = Object.filter(this.state, s => s.shouldValidate),
            state = Object.filter(this.state, s => s.isRequired),
            fieldstateValidateKeys = Object.keys(stateValidate),
            fieldStateKeys = Object.keys(state);

        for (let s in stateValidate) {
            if (await !checkInput(stateValidate[s], this.setErrorMessage))
                isError = true;
            j++;
        }

        for (let k in fieldStateKeys) {
            jsonBody = Object.assign(jsonBody, {
                [fieldStateKeys[k]]: returnValue(state[fieldStateKeys[k]])
            });
        }

        if (isError && j == fieldstateValidateKeys.length) {
            this.setState({
                isLoading: false,
                isBusy: false
            });
            return;
        }
        // Thats for the osem independence day
        jsonBody["ExtraField1"] = this.state.TOS2 ? "כן" : "לא"
        this.setState(
            {
                jsonBody,
                isLoading: true,
                isBusy: true
            },
            () =>
                this.state.captchaEnable
                    ? window.grecaptcha.execute()
                    : this.sendForm()
        );
    };

    sendForm = async () => {
        let formData = new FormData();
        let formDataEmailPhone = new FormData();
        const { jsonBody } = this.state;
        // console.log(jsonBody);
        

        let source = new URLSearchParams(window.location.search).get('utm_source');
        let medium = new URLSearchParams(window.location.search).get('utm_medium');
        let campaign = new URLSearchParams(window.location.search).get('utm_campaign');
        let term = new URLSearchParams(window.location.search).get('utm_term');
        let content = new URLSearchParams(window.location.search).get('utm_content');
        let gaClientID = _getCookie("_ga");
        if (gaClientID) {
            gaClientID = gaClientID.split(".").slice(-2).join(".");
        }
        formData.append("utmSource", source ? source : "");
        formData.append("utmMedium", medium ? medium : "");
        formData.append("utmCampaign", campaign ? campaign : "");
        formData.append("utmContent", content ? content : "");
        formData.append("utmTerm", term ? term : "");
        formData.append("gaClientID", gaClientID ? gaClientID : "");

        formData.append('LeadID', leadID.toString());
        formDataEmailPhone.append('LeadID', leadID.toString());
        for (let k = 0; k < Object.keys(jsonBody).length; k++) {
            let _key = Object.keys(jsonBody)[k];
            formData.append(_key, jsonBody[_key]);
            if (_key == 'PhoneNumber' || _key == 'Email') {
                formDataEmailPhone.append(_key, jsonBody[_key]);
            }
        }

        this.state.captchaEnable ? window.grecaptcha.reset() : null;

        fetch(`${apiURL}Save`, {
            method: 'POST',
            body: formData
        })
            .then(data => data.json())
            .then(data => {
                this.setState({
                    isLoading: false,
                    isBusy: false,
                    pageStyle: 'done'
                });
                
                GA_Push("Form_Events", "Form Sent", "Osem Balanced kitchen", "Lead Form")
                window.localStorage.setItem('OSEM_AlreadySent', true);
                if (this.state.captchaEnable) {
                    window.grecaptcha.reset();
                }
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                    isBusy: false
                });
            });
    };
    render() {
        return (
            <section className={`section-form ${this.state.pageStyle}`}>
                <div className="wrapper">
                    <div className="res_wrapper">
                        <DomField
                            className="reg_input"
                            type="text"
                            max={64}
                            label="שם מלא"
                            placeholder="שם מלא"
                            name="FullName"
                            id="FullName"
                            isRequired
                            shouldValidate
                            onChange={this.handleInputChange}
                            onLoad={this.addState}
                            {...this.state}
                        />
                        <DomField
                            className="reg_input"
                            type="text"
                            max={100}
                            label="כתובת"
                            placeholder="כתובת"
                            name="PlainText2"
                            id="PlainText2"
                            isRequired
                            shouldValidate
                            onChange={this.handleInputChange}
                            onLoad={this.addState}
                            {...this.state}
                        />
                    </div>
                    <div className="res_wrapper">
                        <DomField
                            className="reg_input"
                            type="tel"
                            max={64}
                            label="טלפון"
                            placeholder="טלפון"
                            name="PhoneNumber"
                            id="PhoneNumber"
                            isRequired
                            shouldValidate
                            onChange={this.handleInputChange}
                            onLoad={this.addState}
                            {...this.state}
                        />
                        <DomField
                            className="reg_input"
                            type="email"
                            max={100}
                            label='דוא"ל'
                            placeholder='דוא"ל'
                            name="Email"
                            id="Email"
                            isRequired
                            shouldValidate
                            onChange={this.handleInputChange}
                            onLoad={this.addState}
                            {...this.state}
                        />
                    </div>
                    <DomTextarea
                        className="texterea"
                        _settings={{
                            maxLength: 5000
                        }}
                        type="text"
                        label="כתבו את הברכה שלכם:"
                        placeholder="כתבו את הברכה שלכם:"
                        name="PlainText"
                        id="PlainText"
                        className=""
                        isRequired
                        shouldValidate
                        onChange={this.handleInputChange}
                        onLoad={this.addState}
                        {...this.state}
                    />
                    <Loading showLoading={this.state.isLoading} />
                    <DomBoolCheckbox
                        label={`סמנו כאן אם ברצונכם שעל גבי המארז אשר ייתרם ע"י אסם-נסטלה יופיע שמכם המלא (בכפוף  לתקנון)`}
                        type="checkbox"
                        name="TOS2"
                        id="TOS2"
                        className="cb"
                        shouldValidate
                        onChange={this.handleInputChange}
                        //onLoad={this.addState}
                        {...this.state}
                    />
                    <DomBoolCheckbox
                        label={`קראתי, הבנתי ואני מסכים
                        <a href="http://z.ynet.co.il/mShort/generics/Leads/TOS/90" target="_blank"> לתקנון הפעילות</a>
                        ולמסירת הפרטים למאגר הצרכנים של קבוצת אסם, בהתאם 
                         <a href="https://www.osem-nestle.co.il/privacy-page" target="_blank">למדיניות הפרטיות</a>
                          של אסם. כמו כן, הנני מסכים בזאת, לקבלת הטבות, מבצעים ועדכונים מקבוצת אסם, בקשר למותגים אסם, נסטלה, נסקפה, מטרנה, גרבר,צבר, בונזו'ר, טבעול, ויטמינצ'יק, סטארבקס, קיטקט, סמארטיס, בישולים ופורינה, בכל אחד מערוצי התקשורת`}
                        // label={`קראתי הבנתי ומסכים
                        // <a target="_blank" href="">לתקנון הפעילות.</a>
                        // בעת הרשמתי אני מסכים למסירת הפרטים למאגר הצרכנים של קבוצת אסם, בהתאם 
                        // <a target='_blank' href='https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html'>למדיניות הפרטיות</a>
                        // ולקבלת הטבות, מבצעים ועדכונים מ’אסם’ ו/או 
                        // מחברות ’קבוצת אסם’: נסטלה, נסקפה, מטרנה, צבר, בונזו'ר, ויטמינצ'יק, סטארבקס, קיטקט, סמארטיס, בישולים ופורינה,
                        //   בכל אחד מערוצי התקשורת.`}
                        type="checkbox"
                        name="TOS"
                        id="TOS"
                        className="cb"
                        shouldValidate
                        onChange={this.handleInputChange}
                        onLoad={this.addState}
                        {...this.state}
                    />
                    <div
                        className="button"
                        onClick={() => {
                            this.saveAndValidate();
                        }}>
                        <div
                            className="g-recaptcha"
                            data-callback="sendCallback"
                            data-size="invisible"
                            data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"></div>
                    </div>
                </div>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Body/Body.jsx